import { Input } from '@vimily/bonjoro-ui-components-v2/Input';
import React from 'react';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';

export interface RequestPositionFieldProps {
  label?: string;
  placeholder?: string;
  defaultValue?: string;
  onChange: (value: string) => void;
  fontColor?: string;
}

export default function RequestPositionField({
  label,
  placeholder = 'eg. CEO@Bonjoro',
  defaultValue = '',
  onChange,
  fontColor,
}: RequestPositionFieldProps) {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col items-start mb-5'>
      <span className='pb-3 text-sm font-bold' style={{color: fontColor}}>
        {label ?? t('testimonial:request.position')}
      </span>
      <Input
        type='text'
        defaultValue={defaultValue}
        onChange={(event: React.FormEvent<HTMLInputElement>) =>
          onChange((event.target as HTMLInputElement).value)
        }
        className={cx([
          'v2-text-neutral-900 !px-4 !py-0 !h-10',
          'v2-border v2-border-solid !v2-border-neutral-300',
          'hover:!v2-border-neutral-300 focus:!v2-border-neutral-300'
        ])}
        placeholder={placeholder}
      />
    </div>
  );
}
